import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200 px-8 py-6 mt-auto">
      <div className="text-center text-sm text-slate-600">
        <p>© 2026 Villa Experience - Owner & Villa Management</p>
        <p className="mt-1 text-xs text-slate-500">Oliver Weickardt - Business Software</p>
      </div>
    </footer>
  )
}

export default Footer










